module.exports = __webpack_public_path__ + "img/haixian.8f778813.png";